import { render } from "./PasswordResetView.vue?vue&type=template&id=513d22f1"
import script from "./js/passwordResetView.js?vue&type=script&lang=js&external"
export * from "./js/passwordResetView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__